import { createSvgIcon } from '@mui/material'

export const StraddleCarrierIcon = createSvgIcon(
  <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M2 1C2 0.447715 2.44772 0 3 0H17C17.5523 0 18 0.447715 18 1V2C18 2.55228 17.5523 3 17 3H16V5H19C19.5523 5 20 5.44772 20 6C20 6.55229 19.5523 7 19 7H16V13H19C19.5523 13 20 13.4477 20 14V18C20 18.5523 19.5523 19 19 19H17.8293C17.9398 18.6872 18 18.3506 18 18C18 16.3431 16.6569 15 15 15C13.3431 15 12 16.3431 12 18C12 18.3506 12.0602 18.6872 12.1707 19H7.82929C7.93985 18.6872 8 18.3506 8 18C8 16.3431 6.65685 15 5 15C3.34315 15 2 16.3431 2 18C2 18.3506 2.06015 18.6872 2.17071 19H1C0.447716 19 0 18.5523 0 18V14C0 13.4477 0.447715 13 1 13H4V7H1C0.447716 7 0 6.55229 0 6C0 5.44772 0.447715 5 1 5H4V3H3C2.44772 3 2 2.55228 2 2V1ZM6 7V13H14V7H6ZM14 5H6V3H14V5Z'
      fill='black'
    />
    <path
      d='M17 18C17 19.1046 16.1046 20 15 20C13.8954 20 13 19.1046 13 18C13 16.8954 13.8954 16 15 16C16.1046 16 17 16.8954 17 18Z'
      fill='black'
    />
    <path
      d='M5 20C6.10457 20 7 19.1046 7 18C7 16.8954 6.10457 16 5 16C3.89543 16 3 16.8954 3 18C3 19.1046 3.89543 20 5 20Z'
      fill='black'
    />
  </svg>,
  'StraddleCarrierHandler',
)
